/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum PseudonymAppointmentsConfirmationDetailAliases {
  FRAGMENT_REFERENCE_APPOINTMENT_DETAIL_SUMMARY = 'fragment-reference-appointment-detail-summary',
  LAYOUT_DETAIL = 'layout-detail',
  PANEL_DETAIL = 'panel-detail',
}
export { PseudonymAppointmentsConfirmationDetailAliases };
